/**
 * Second loading attempt for the wishlist app (Wishlist Engine).
 *
 * The app requests its settings once per page view (POST /api/apps-config on its own server)
 * and only then draws the hearts, binds their clicks and fills the wishlist counter. When that
 * request fails, the hearts stay empty for the rest of the page view. If the settings are still
 * missing a few seconds after the page has loaded, this script starts the app's loader again,
 * at most twice. The request usually finishes before the load event, so a request that is
 * still running is not doubled.
 */
(() => {
  /** Waiting time before each check, counted from the load event and then from the previous check. */
  const CHECK_DELAYS = [3000, 12000];

  const settingsLoaded = () => {
    const data = /** @type {any} */ (window).app_widget_data;
    return typeof data === 'object' && data !== null && 'is_enable_app' in data;
  };

  const getAppLoader = () => {
    const app = /** @type {any} */ (window).app_widget_load;
    return app && typeof app._appWidgetLoad === 'function' ? app : null;
  };

  let checks = 0;

  const scheduleCheck = () => {
    if (checks >= CHECK_DELAYS.length) {
      return;
    }
    window.setTimeout(checkSettings, CHECK_DELAYS[checks]);
    checks += 1;
  };

  const checkSettings = () => {
    if (settingsLoaded()) {
      return;
    }
    const app = getAppLoader();
    if (app) {
      try {
        // Internal function of the app: requests the settings again and, on success,
        // draws the hearts, binds their clicks and updates the counter.
        app._appWidgetLoad();
      } catch (error) {
        // The app may change its internals with an update; the placeholder hearts stay then.
      }
    }
    scheduleCheck();
  };

  if (document.readyState === 'complete') {
    scheduleCheck();
  } else {
    window.addEventListener('load', scheduleCheck, { once: true });
  }
})();
